import { render, staticRenderFns } from "./Recommended.vue?vue&type=template&id=2f2b2a87&scoped=true"
import script from "./Recommended.vue?vue&type=script&lang=js"
export * from "./Recommended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2b2a87",
  null
  
)

export default component.exports